import React from "react";
import {
  Spin,
  Divider,
  Row,
  Col
} from "antd";
import global from "../../../common/utility/global";
import Header from "../../../components/Header";
import Filters from "../DashboardEstablecimiento/Filters";
import anioMock from '../../../common/mock/anioMock';
import mesMock from '../../../common/mock/mesMock';
import GraficoRankingTotalVentas from "./GraficoRankingTotalVentas";
import GraficoRankingCantidadComprobante from "./GraficoRankingCantidadComprobante";
import GraficoControlComprobanteEstado from "./GraficoControlComprobanteEstado";
import GraficoTotalVentasTipoComprobante from "./GraficoTotalVentasTipoComprobante";
import GraficoCantidadComprobanteTipoComprobante from "./GraficoCantidadComprobanteTipoComprobante";
import GraficoTotalVentasMensual from "./GraficoTotalVentasMensual";
import GraficoTotalVentas from "./GraficoTotalVentas";
import GraficoCantidadComprobante from "./GraficoCantidadComprobante";
import comprobanteService from "../../../service/ventas/comprobanteService";
import GraficoControlMoneda from "./GraficoControlMoneda";

export default class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      anios: anioMock.values,
      meses: mesMock.values,
      filter: {
        anioInicio: global.fetchCurrentYear(true),
        mesInicio: global.fetchCurrentMonth(true),
        anioFin: global.fetchCurrentYear(),
        mesFin: global.fetchCurrentMonth()
      },
      ///CLIENTE
      graficoRankingTotalVentas: {
        series: [],
        vendedores: [],
      },
      graficoRankingCantidadComprobante: {
        series: [],
        vendedores: [],
      },
      graficoControlComprobanteEstado: {
        series: [],
        vendedores: [],
      },
      graficoTotalVentasMensual: {
        series: [],
        timeLine: [],
      },
      graficoTotalVentasTipoComprobante: {
        series: [],
        vendedores: [],
      },
      graficoCantidadComprobanteTipoComprobante: {
        series: [],
        vendedores: [],
      },
      graficoTotalVentas: {
        series: [],
        vendedores: [],
      },
      graficoTotalUsd: {
        series: [],
        vendedores: [],
      },
      graficoCantidadComprobante: {
        series: [],
        vendedores: [],
      },
    };
  }

  handleChange = (property, value) => {
    const filter = { ...this.state.filter, [property]: value };
    this.setState({ filter });
  };

  handleClearFilters = () => {

    this.setState({
      fechaInicioStr: global.fetchCurrentDateStr(true),
      fechaFinStr: global.fetchCurrentDateStr(),
    });
  };

  handleGenerateReport = async (filter) => {
    debugger
    this.setState({
      loading: true,
    });
    const response = await comprobanteService.dashboardVendedor(filter);
    if (response !== undefined)

      this.setState({
        graficoRankingTotalVentas: {
          series: response.dataGraficoRankingTotalVentas,
          vendedores: response.dataVendedorOrderTotal,
        },
        graficoRankingCantidadComprobante: {
          series: response.dataGraficoRankingCantidadComprobante,
          vendedores: response.dataVendedorOrderCantidad,
        },
        graficoControlComprobanteEstado: {
          series: response.dataGraficoControlComprobanteEstado,
          vendedores: response.dataVendedorOrderCantidad,
        },
        graficoTotalVentasTipoComprobante: {
          series: response.dataGraficoTotalVentasTipoComprobante,
          vendedores: response.dataVendedorOrderTotal,
        },
        graficoCantidadComprobanteTipoComprobante: {
          series: response.dataGraficoCantidadComprobanteTipoComprobante,
          vendedores: response.dataVendedorOrderCantidad,
        },
        graficoTotalVentasMensual: {
          series: response.dataGraficoTotalVentasMensual,
          timeLine: response.dataTimeLine,
        },
        graficoTotalVentas: {
          series: response.dataGraficoTotalVentas,
          vendedores: response.dataVendedorOrderTotal,
        },
        graficoTotalUsd: {
          series: response.dataGraficoTotalUSD,
          vendedores: response.dataVendedorOrderTotal,
        },
        graficoCantidadComprobante: {
          series: response.dataGraficoCantidadComprobante,
          vendedores: response.dataVendedorOrderCantidad,
        },
        loading: false
      });
  };

  async componentDidMount() {
    await this.handleGenerateReport(this.state.filter);
    this.setState({
      loading: false,
    });
  }

  render() {
    return (
      <div>
        <Header
          title="Dashboard de Ventas por Vendedor"
          onClearFilters={this.handleClearFilters}
          onSearch={() => this.handleGenerateReport(this.state.filter)}
        />
        <Divider />
        <Filters filter={this.state.filter} anios={this.state.anios} meses={this.state.meses} onChange={this.handleChange} />
        <Spin tip="Cargando..." size="large" spinning={this.state.loading}>

          {/* <Row gutter={50}>
            <Col className="gutter-row" sm={24} md={12} lg={12}>
              <GraficoTotalVentasTipoComprobante
                  series={this.state.graficoTotalVentasTipoComprobante.series}
                  vendedores={
                    this.state.graficoTotalVentasTipoComprobante.vendedores
                  }
                />
            </Col>
            <Col className="gutter-row" sm={24} md={12} lg={12}>
            <GraficoCantidadComprobanteTipoComprobante
                series={this.state.graficoCantidadComprobanteTipoComprobante.series}
                vendedores={
                  this.state.graficoCantidadComprobanteTipoComprobante.vendedores
                }
              />
            </Col>
        </Row> */}
          <Divider className="mb-20" />
          <Row gutter={16}>
            <Col className="gutter-row" sm={24} md={24} lg={24}>
              <GraficoTotalVentasMensual
                series={this.state.graficoTotalVentasMensual.series}
                timeLine={
                  this.state.graficoTotalVentasMensual.timeLine
                }
              />
            </Col>
          </Row>
          <Divider className="mb-20" />
          <Row gutter={50}>
            <Col className="gutter-row" sm={24} md={12} lg={12}>
              <GraficoTotalVentas
                series={this.state.graficoTotalVentas.series}
                vendedores={this.state.graficoTotalVentas.vendedores}
              />
            </Col>
            <Col className="gutter-row" sm={24} md={12} lg={12}>
              <GraficoCantidadComprobante
                series={this.state.graficoCantidadComprobante.series}
                vendedores={this.state.graficoCantidadComprobante.vendedores}
              />
            </Col>
          </Row>
          <Divider className="mb-20" />
          <Row gutter={16}>
            <Col className="gutter-row" sm={24} md={24} lg={24}>
              <GraficoControlMoneda
                series={[
                  { name: 'SOLES', data: this.state.graficoTotalVentas.series, group: 'entrada' },
                  { name: 'DOLARES', data: this.state.graficoTotalUsd.series, group: 'salida' }
                ]}
                vendedores={this.state.graficoControlComprobanteEstado.vendedores}
              />
            </Col>
          </Row>

          <Divider className="mb-20" />

          <Row gutter={16}>
            <Col className="gutter-row" sm={24} md={24} lg={24}>
              <GraficoControlComprobanteEstado
                series={this.state.graficoControlComprobanteEstado.series}
                vendedores={this.state.graficoControlComprobanteEstado.vendedores}
              />
            </Col>
          </Row>
          {/* <Row gutter={16}>
            <Col className="gutter-row" sm={24} md={24} lg={24}>
                <GraficoRankingTotalVentas
                series={this.state.graficoRankingTotalVentas.series}
                vendedores={this.state.graficoRankingTotalVentas.vendedores}
              />
            </Col>
        </Row>
        <Divider className="mb-20" />
        <Row gutter={16}>
            <Col className="gutter-row" sm={24} md={24} lg={24}>
                <GraficoRankingCantidadComprobante
                series={this.state.graficoRankingCantidadComprobante.series}
                vendedores={this.state.graficoRankingCantidadComprobante.vendedores}
              />
            </Col>
        </Row> */}

          {/* <Row gutter={16}>
            <Col className="gutter-row" sm={24} md={24} lg={24}>
                <GraficoControlComprobanteEstado
                series={this.state.graficoControlComprobanteEstado.series}
                vendedores={this.state.graficoControlComprobanteEstado.vendedores}
              />
            </Col>
        </Row> */}
        </Spin>
      </div>
    );
  }
}
